export default __webpack_public_path__ + "static/media/contemporary.ae2257a9.png";